module.exports = __webpack_public_path__ + "img/error_fondo.a9ff26fb.svg";